const {Fancybox} = require("@fancyapps/ui");

module.exports = {
  init: function () {

    Fancybox.bind('[data-fancybox="gallery"]', {
      buttons: [
        // "zoom",
        //"share",
        // "slideShow",
        // "fullScreen",
        //"download",
        // "thumbs",
        "close",
      ],
      loop: false,
      protect: true,
    });

    const gallery = $('.js-carousel-gallery');
    if (gallery.length > 0) {
      $(gallery).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.js-carousel-gallery-thumbs'
      });
      $('.js-carousel-gallery-thumbs').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: gallery,
        dots: false,
        centerMode: true,
        arrows: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 767.98,
            settings: {
              arrows: false,
              slidesToShow: 2,
            }
          },
        ]
      });

      // gallery.slick({
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   arrows: false,
      //   dots: true,
      //   centered: true,
      //   autoplay: true,
      //   autoplaySpeed: 6000,
      //   customPaging: function(slider, i) {
      //     console.log(slider.$slides[i]);
      //     return '<button><span class="thumbImg" style="background-image:url('+$(slider.$slides[i]).data('thumb')+');"></span></button>';
      //   },
      // });
    }
  }
}
